import axios from "axios";
import { useEffect, useState, useRef } from "react";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
import constants from "../../constants";
import moment from "moment";
import { Search, Loader2, ChevronDown, ChevronUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Form,
  Input,
  Radio,
  Row,
  Col,
  Divider,
  DatePicker,
  TimePicker,
  Select,
  Space,
  Card,
  Typography,
  message,
  List,
  Skeleton,
  Table,
  Tooltip,
  Badge,
  Statistic,
  Modal,
  Avatar,
  Switch,
  Tag,
  Popconfirm,
  Segmented,
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  WhatsAppOutlined,
  CheckOutlined,
  CloseCircleTwoTone,
  ClockCircleTwoTone,
  ReloadOutlined,
  ScissorOutlined,
  BankOutlined,
  RocketTwoTone,
  StarFilled,
  NodeIndexOutlined,
  PlusOutlined,
  DiffOutlined,
  PercentageOutlined,
  HomeOutlined,
  LoadingOutlined,
  InfoCircleTwoTone,
  UserOutlined,
  MailTwoTone,
  QuestionCircleOutlined,
  BarsOutlined,
  AppstoreOutlined,
  SendOutlined,
  RightCircleFilled,
  CalendarOutlined,
  ClearOutlined,
  MailFilled,
} from "@ant-design/icons";
import { AutoComplete } from "antd";
import Loader from "../../util/loader";
import useView from "../../hooks/useView";
import Meta from "antd/es/card/Meta";
import { useAuth } from "../../contexts/authContext";
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;
const AddLead = () => {
  const { RangePicker } = DatePicker;
  const { currentUser, roles } = useAuth();
  const [dateRange, setDateRange] = useState(null);
  const [dateRangeReport, setDateRangeReport] = useState(null);
  const isAFS = roles.includes("AFS");
  const isGLENTREE = roles.includes("GLENTREE");
  const [data, setData] = useState();
  const [schoolId, setSchoolId] = useState({
    verified: false,
    previousValue: "",
  });
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [total, settotal] = useState(0);
  const [analytics, setAnalytics] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [school, setSchool] = useState();
  const { width } = useView();
  const navigate = useNavigate();
  const searchInput = useRef(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const [value, setValue] = useState();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      position: ["topCenter"],
    },
    filters: {},
  });
  const { isMobile } = useView();
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");
  const [viewType, setViewType] = useState("CRM");
  const [filteredSchools, setFilteredSchools] = useState([]);

  const currentYear = moment().year();
  const setSessionYear = (year) => {
    const start = moment(`${year}-01-01`);
    const end = moment(`${year}-12-31`);
    setDateRangeReport([start, end]);
    // fetchReportData(false,id,[start, end])
  };

  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
    }, 2000);
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  const getPanelValue = async (searchText) => {
    /* ── 1. abort on empty input ─────────────────────────────────────────── */
    if (!searchText?.trim()) {
      setOptions([]); // clear suggestions
      return [];
    }

    /* ── 2. optimistic UI while we fetch ─────────────────────────────────── */
    // setLoading(true);
    setOptions([{ value: "Loading…" }]); // skeleton item

    try {
      /* ── 3. build an **encoded** regex query for Parse ─────────────────── */
      const where = encodeURIComponent(
        JSON.stringify({
          ascii_name: {
            $regex: `^${searchText}`,
            $options: "i",
          },
        }),
      );

      const url = `https://parseapi.back4app.com/classes/Indiacities_india_cities_database` + `?limit=10&keys=ascii_name,latitude,longitude&where=${where}`;

      /* ── 4. only the two Parse headers are required – drop Authorization ─ */
      const res = await axios.get(url, {
        headers: {
          "X-Parse-Application-Id": process.env.REACT_APP_CITY_API_ID || "QGbWT4XShAT2mbLgskFhhR8IsKlUwIzbg60sPofs",
          "X-Parse-REST-API-Key": process.env.REACT_APP_CITY_API_KEY || "W3nwydEEB9VswTJY46aVZDdnd6QTZW1tiiaCcDce",
        },
      });

      /* ── 5. transform results for <AutoComplete /> ────────────────────── */
      const options =
        res.status === 200
          ? res.data.results.map((city) => ({
              value: city.ascii_name, // what gets filled into the input
              key: city.objectId, // unique key
              lat: city.latitude,
              lon: city.longitude,
            }))
          : [];

      setOptions(options);
      return options;
    } catch (err) {
      console.error("City lookup failed:", err?.response || err);
      setOptions([]);
      return [];
    } finally {
      /* ── 6. always release the spinner ─────────────────────────────────── */
      setLoading(false);
    }
  };
  const fetchSchool = async (date) => {
    setTableLoading(true);
    let query = [];
    console.log(tableParams);
    Object.keys(tableParams.filters).forEach((k) => {
      if (tableParams.filters[k] !== null && tableParams.filters[k].length > 0) {
        // query.push(`${k}=${tableParams.filters[k]}`)
        if (k === "name") {
          query.push(`${k}:sw=${tableParams.filters[k]}`);
        } else if (k === "city") {
          query.push(`${k}:sw=${tableParams.filters[k]}`);
        } else if (k === "nextFollowUp") {
          query.push(
            `nextFollowUp:gte=${new Date(tableParams.filters[k][0]).toISOString()}&nextFollowUp:lt=${new Date(tableParams.filters[k][1]).toISOString()}`,
          );
        } else if (k === "orientationDate") {
          query.push(
            `orientationDate:gte=${new Date(tableParams.filters[k][0]).toISOString()}&orientationDate:lt=${new Date(tableParams.filters[k][1]).toISOString()}`,
          );
        } else if (k === "lastReportDate") {
          query.push(
            `lastReportDate:gte=${new Date(tableParams.filters[k][0]).toISOString()}&lastReportDate:lt=${new Date(tableParams.filters[k][1]).toISOString()}`,
          );
        } else if (k === "sessionStartDate") {
          query.push(
            `sessionStartDate:gte=${new Date(tableParams.filters[k][0]).toISOString()}&sessionStartDate:lt=${new Date(tableParams.filters[k][1]).toISOString()}`,
          );
        } else {
          query.push(`${k}=${tableParams.filters[k]}`);
        }
      }
    });

    if (viewType === "FOLLOWUP") {
      let sd = new Date((date && date[0]) || new Date());
      sd.setHours(0, 0, 0, 0);
      let ed = new Date((date && date[1]) || new Date());
      ed.setDate(ed.getDate() + 1);
      ed.setHours(0, 0, 0, 0);

      let sdISO = sd.toISOString();
      let edISO = ed.toISOString();

      query.push(`nextFollowUp:gte=${sdISO}&nextFollowUp:lt=${edISO}`);
      query.push(`acknowledged=true`);
    }
    //   name={$regex:^fin,$options:'i'}&

    query = `page=${tableParams.pagination.current}&limit=${tableParams.pagination.pageSize}&` + query.join("&");
    if (Object.keys(tableParams.filters).length === 0) {
      let queryLocal = sessionStorage.getItem("leadcrmb2b");
      if (queryLocal) query = queryLocal;
    } else if (!isGLENTREE && !isAFS) {
      sessionStorage.setItem("leadcrmb2b", query);
    }
    try {
      const url = `${constants.NEW_DOMAIN}/api/v1/school/fetchSchools?${isAFS ? "partner=AFS&" : isGLENTREE ? "name:sw=Glentree&" : ""}${query}`;
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
        },
      });
      setSchool(res.data.data.schools);
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: res.data.results,
        },
      });
      setTableLoading(false);
    } catch (error) {
      setTableLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    if (viewType === "FLOTATION") fetchFlotation();
    else fetchSchool();
  }, [JSON.stringify(tableParams), viewType]);

  const handleSave = async (values) => {
    console.log(values);
    const orientationDate = new Date(values.date);
    const orientationTime = new Date(values.time);
    orientationDate.setHours(orientationTime.getHours(), orientationTime.getMinutes(), 0, 0);
    setLoading(true);
    try {
      const body = {
        schoolId: values.schoolId.replace(/\s/g, ""),
        name: values.name,
        numberOfStudents: values.numberOfStudents,
        notes: values.notes,
        city: values.city,
        refferalCode: values.refferalCode,
        state: values.state,
        orientationDate: orientationDate,
        ...(values.customPrice && { customPrice: values.customPrice }),
        ...((values.POC_Name || values.POC_Email || values.POC_Phone || values.POC_Designation) && {
          POC: {
            name: values.POC_Name,
            contact: values.POC_Phone,
            email: values.POC_Email,
            designation: values.POC_Designation,
          },
        }),
        nextFollowUp: new Date(values.nextFollowUp),
        sessionStartDate: new Date(values.sessionStartDate),
        schoolCoordinator: values.POC_Name,
        inTake: values.inTake,
        showDubai: values.showDubai,
        showCosco: values.showCosco,
        mainGroupLink: values.mainGroupLink,
        logoUrl: values.logoUrl,
        leadType: values.leadType,
        POC_V1: values.POC_V1,
        partner: values.partner,
        followupType: values.followupType,
      };
      const url = `${constants.NEW_DOMAIN}/api/v1/school/createAndUpdateSchools`;
      const res = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
        },
      });
      messageApi.open({
        type: "success",
        content: "Saved successfully",
      });
      // update the record here, so that no explicit refresh is required
      fetchSchool();
      setOpen(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      messageApi.open({
        type: "error",
        content: error.response.data.message || "Something went wrong",
      });
      console.log(error.response.data.message);
      setOpen(false);
      fetchSchool();
    }
  };
  const handleReset = (clearFilters) => {
    // sessionStorage.setItem('leadcrmb2b','page=1&limit=10&')
    sessionStorage.clear();
    clearFilters();
    fetchSchool();
  };
  const fetchSchoolId = async (id) => {
    setIsModalOpen(true);
    try {
      const url = `${constants.NEW_DOMAIN}/api/v1/school/getAnalyticsById/${id}`;
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
        },
      });
      console.log(res);
      setAnalytics(res.data.data);
      setModalLoading(false);
    } catch (error) {
      setModalLoading(false);
      console.log(error);
    }
  };
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTableParams({
      ...tableParams,
      pagination: { ...tableParams.pagination, current: 1 }, //reset the page to 1
      filters: {
        [dataIndex]: selectedKeys,
      },
    });
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={dataIndex === "nextFollowUp" ? "YYYY-MM-DD" : `Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    // onFilter: (value, record) =>
    //   record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const onSelect = (data) => {
    console.log("onSelect", data);
  };
  const columns = [
    {
      title: "",
      width: 48,
      render: (_, record) => {
        return <Space>{renderStatus(_, record)}</Space>;
      },
    },
    // isAFS ?{
    //   width:0
    // }:isGLENTREE?{width: 0}:{
    //   title: "Type",
    //   width: 80,
    //   dataIndex:'partner',
    //   render: (_, record) => {
    //     return <>
    //     {record.partner === "AFS" && <Tag color="blue">AFS</Tag>}
    //     {record.partner === "GLENTREE" && <Tag color="blue">GLENTREE</Tag>}
    //     {record.partner === "YOUVAH" && <Tag color="purple">YouVah</Tag>}
    //     </>
    //   },
    //   ...getColumnSearchProps("partner"),
    // },
    {
      title: "School Name",
      dataIndex: "name",
      //   fixed: "left",
      width: 195,
      sorter: false,
      render: (_, record) => {
        return (
          <a
            onClick={() => {
              form.resetFields();
              form.setFieldsValue(record);
              if (record.orientationDate) {
                const date = dayjs(record.orientationDate);
                form.setFieldValue("date", date);
                form.setFieldValue("time", date);
              }
              if (record.nextFollowUp) {
                const date = dayjs(record.nextFollowUp);
                form.setFieldValue("nextFollowUp", date);
                // form.setFieldValue("time", date)
              }
              if (record.sessionStartDate) {
                const date = dayjs(record.sessionStartDate);
                form.setFieldValue("sessionStartDate", date);
                // form.setFieldValue("time", date)
              }
              if (record.POC) {
                form.setFieldValue("POC_Name", record.POC.name);
                form.setFieldValue("POC_Phone", record.POC.contact);
                form.setFieldValue("POC_Email", record.POC.email);
                form.setFieldValue("POC_Designation", record.POC.designation);
              }
              setSchoolId({
                ...schoolId,
                previousValue: record.schoolId,
              });
              showModal();
            }}
          >
            <div style={{ display: "flex", position: "relative" }}>
              <span>{record.name}</span>
              <span style={{ position: "absolute", top: "-28px" }}>
                {record.partner === "AFS" && (
                  <Tag
                    style={{
                      fontSize: 10, // ↓ smaller text
                      lineHeight: "16px", // align text vertically
                      padding: "0 4px", // tighter left-right space
                      height: "auto", // let height follow content
                    }}
                    color="blue"
                  >
                    AFS
                  </Tag>
                )}
                {record.partner === "GLENTREE" && (
                  <Tag
                    style={{
                      fontSize: 10, // ↓ smaller text
                      lineHeight: "16px", // align text vertically
                      padding: "0 4px", // tighter left-right space
                      height: "auto", // let height follow content
                    }}
                    color="blue"
                  >
                    GLENTREE
                  </Tag>
                )}
                {record.partner === "YOUVAH" && (
                  <Tag
                    style={{
                      fontSize: 10, // ↓ smaller text
                      lineHeight: "16px", // align text vertically
                      padding: "0 4px", // tighter left-right space
                      height: "auto", // let height follow content
                    }}
                    color="purple"
                  >
                    YouVah
                  </Tag>
                )}
              </span>
            </div>
          </a>
        );
      },
      ...getColumnSearchProps("name"),
    },
    {
      title: "W",
      dataIndex: "refferalCode",
      sorter: false,
      width: 50,
      render: (data, record) =>
        data ? (
          <Tooltip
            color="white"
            title={
              <Card
                bordered={false}
                size="small"
                style={{
                  minWidth: 150,
                }}
              >
                <p>
                  🔗 :{" "}
                  {(
                    <Text
                      copyable={{
                        text: `https://youvah.com/school/${data}`,
                      }}
                    >{`https://youvah.com/school/${data}`}</Text>
                  ) || "N/A"}
                </p>
                <p>code : {data || "N/A"}</p>
              </Card>
            }
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <p>
                <InfoCircleTwoTone />
              </p>
            </div>
          </Tooltip>
        ) : (
          <Tag color={"red"}>N/A</Tag>
        ),
    },
    {
      title: "City",
      dataIndex: "city",
      width: 120,
      sorter: false,
      //   fixed: "left",
      ...getColumnSearchProps("city"),
    },
    {
      title: "School POC Details",
      dataIndex: "POC",
      sorter: false,
      width: 150,
      render: (data) =>
        data ? (
          <Tooltip
            color="white"
            title={
              <Card
                bordered={false}
                size="small"
                style={{
                  minWidth: 150,
                }}
              >
                <Meta
                  avatar={
                    <Avatar
                      style={{
                        backgroundColor: "#971eff",
                      }}
                      icon={<UserOutlined />}
                    />
                  }
                  title={data.name}
                  description={`Designation : ${data.designation || "UNKOWN"}`}
                />
                <p>✉️ : {data.email || "N/A"}</p>
                <p>📞 : {data.contact || "N/A"}</p>
              </Card>
            }
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar
                size={32}
                style={{
                  backgroundColor: "#f2f2f2",
                  color: "gray",
                  marginRight: "10px",
                }}
              >
                {data.name ? data.name[0] : <UserOutlined />}
              </Avatar>
              <p>{data.name}</p>
            </div>
          </Tooltip>
        ) : (
          "N/A"
        ),
    },
    {
      title: "POC",
      dataIndex: "POC_V1",
      sorter: false,
      width: 100,

      render: (data) => (data ? <p style={{ color: "gray" }}>{data}</p> : <p>N/A</p>),
      ...getColumnSearchProps("POC_V1"),
    },

    // {
    //   title: "Lead Type",
    //   dataIndex: "leadType",
    //   width: 120,
    //   filters: [
    //     {
    //       text: "HOT",
    //       value: "HOT",
    //     },
    //     {
    //       text: "COLD",
    //       value: "COLD",
    //     },
    //     {
    //       text: "CONVERTED",
    //       value: "CONVERTED",
    //     },
    //     {
    //       text: "DIRECT",
    //       value: "DIRECT",
    //     },
    //   ],
    //   render: (leadType) => {
    //     let color = {
    //       HOT: "geekblue",
    //       COLD: "volcano",
    //       CONVERTED: "green",
    //     }
    //     return <Tag color={color[leadType]}>{leadType}</Tag>
    //   },
    // },
    isAFS
      ? {
          width: 0,
        }
      : isGLENTREE
        ? { width: 0 }
        : {
            title: "Next Follow up",
            dataIndex: "nextFollowUp",
            sorter: false,
            width: 150,

            render: (date, record) => (
              <Tooltip title="Edit Next Follow-Up">
                <DatePicker
                  showTime
                  size="small"
                  onChange={(v) => {
                    if (!v) return;
                    //set in this way to make Date filter work
                    // setOldRecord(record)
                    record.nextFollowUp = new Date(v);
                  }}
                  //   onOk={(v) => {
                  //     console.log(v.toISOString())
                  //   }}
                  defaultValue={date ? dayjs(date) : ""}
                />
                {date && (
                  <p style={{ fontSize: "12px" }}>
                    {" "}
                    Date: {new Date(date).toLocaleDateString()} <br /> Time: {new Date(date).toLocaleTimeString()}
                  </p>
                )}{" "}
              </Tooltip>
            ),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <div style={{ padding: 8 }}>
                <RangePicker
                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD HH:mm"
                  value={selectedKeys[0] ? [selectedKeys[0], selectedKeys[1]] : []}
                  onChange={([from, to]) => setSelectedKeys([from, to])}
                  onOk={() => confirm()}
                />
                <Space>
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedKeys([]);
                      clearFilters();
                    }}
                    style={{ width: 90 }}
                  >
                    Reset
                  </button>
                  <button type="button" onClick={() => confirm()} style={{ width: 90 }}>
                    OK
                  </button>
                </Space>
              </div>
            ),
            // Customize the filter icon
            filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
          },
    isAFS
      ? {
          width: 0,
        }
      : isGLENTREE
        ? { width: 0 }
        : {
            title: "Followup Type",
            dataIndex: "followupType",
            width: 200,
            filters: [
              {
                text: "Connect on call",
                value: "CONNECT_ON_CALL",
              },
              {
                text: "Flotation",
                value: "FLOTATION",
              },
              {
                text: "Floation reminder",
                value: "FLOATION_REMINDER",
              },
              {
                text: "registration data",
                value: "REGISTRATION_DATA",
              },
              {
                text: "send report",
                value: "SEND_REPORT",
              },
              {
                text: "School Orientation",
                value: "SCHOOL_ORIENTATION",
              },
              {
                text: "Student Orientation",
                value: "STUDENT_ORIENTATION",
              },
              {
                text: "UNTOUCHED",
                value: "",
              },
            ],
            render: (followupType, record) => {
              return (
                <Select
                  size="small"
                  defaultValue={followupType || ""}
                  style={{
                    width: 160,
                  }}
                  onChange={(e) => {
                    if (e === "CUSTOM") {
                      // Show modal or input field for custom input
                      const customValue = prompt("Enter custom followup type:");
                      if (customValue && customValue.trim()) {
                        // Convert custom value to uppercase with underscores
                        const formattedValue = customValue.trim().toUpperCase().replace(/\s+/g, "_");
                        record.followupType = formattedValue;
                      }
                    } else {
                      record.followupType = e;
                    }
                  }}
                  options={[
                    {
                      value: "CONNECT_ON_CALL",
                      label: "Connect on call",
                    },
                    {
                      value: "FLOTATION",
                      label: "Flotation",
                    },
                    {
                      value: "FLOATION_REMINDER",
                      label: "Floation reminder",
                    },
                    {
                      value: "REGISTRATION_DATA",
                      label: "Send registration data",
                    },
                    {
                      value: "SEND_REPORT",
                      label: "send report",
                    },
                    {
                      value: "SCHOOL_ORIENTATION",
                      label: "School Orientation",
                    },
                    {
                      value: "STUDENT_ORIENTATION",
                      label: "Student Orientation",
                    },
                    {
                      value: "CUSTOM",
                      label: "Add Custom...",
                    },
                  ]}
                  dropdownRender={(menu) => <div>{menu}</div>}
                />
              );
            },
          },
    isAFS
      ? {
          width: 0,
        }
      : isGLENTREE
        ? { width: 0 }
        : viewType === "FOLLOWUP"
          ? {
              title: "Send Acknowledgement",
              dataIndex: "followupType",
              width: 200,
              render: (followupType, record) => {
                return (
                  <>
                    <Button
                      type="default"
                      icon={<RightCircleFilled />}
                      onClick={() => {
                        acknowledged(record._id);
                      }}
                      loading={loading}
                      style={{ backgroundColor: "green", color: "white" }}
                    >
                      Acknowledged
                    </Button>
                  </>
                );
              },
            }
          : { width: 0 },
    isAFS
      ? {
          width: 0,
        }
      : isGLENTREE
        ? { width: 0 }
        : {
            title: "Notes",
            dataIndex: "notes",
            width: 255,
            render: (notes, record) => {
              return (
                <TextArea
                  rows={3}
                  // value={comments}
                  defaultValue={notes}
                  onChange={(e) => {
                    console.log(e.target.value);
                    // setOldRecord(record)
                    record.notes = e.target.value;
                  }}
                />
              );
            },
          },
    // {
    //   title: "Orientation Date",
    //   dataIndex: "orientationDate",
    //   sorter: false,
    //   width: 150,
    //   render: (orientationDate, record) =>
    //     orientationDate ? (
    //       <>
    //         {new Date(orientationDate).toDateString()}
    //         <div style={{ color: "lightgray" }}>
    //           {new Date(orientationDate).toLocaleTimeString()}
    //         </div>
    //       </>
    //     ) : (
    //       "N/A"
    //     ),
    //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    //       <div style={{ padding: 8 }}>
    //         <RangePicker
    //           showTime={{ format: 'HH:mm' }}
    //           format="YYYY-MM-DD HH:mm"
    //           value={selectedKeys[0] ? [selectedKeys[0], selectedKeys[1]] : []}
    //           onChange={([from, to]) => setSelectedKeys([from, to])}
    //           onOk={() => confirm()}
    //         />
    //         <Space>
    //           <button
    //             type="button"
    //             onClick={() => {
    //               setSelectedKeys([]);
    //               clearFilters();
    //             }}
    //             style={{ width: 90 }}
    //           >
    //             Reset
    //           </button>
    //           <button
    //             type="button"
    //             onClick={() => confirm()}
    //             style={{ width: 90 }}
    //           >
    //             OK
    //           </button>
    //         </Space>
    //       </div>
    //     ),
    //     // Customize the filter icon
    //     filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    // },
    isAFS
      ? {
          width: 0,
        }
      : isGLENTREE
        ? { width: 0 }
        : {
            title: "Session Start Date",
            dataIndex: "sessionStartDate",
            sorter: false,
            width: 150,
            render: (sessionStartDate, record) =>
              sessionStartDate ? (
                <>
                  <Tooltip title="Edit Next Follow-Up">
                    <DatePicker
                      showTime
                      size="small"
                      onChange={(v) => {
                        if (!v) return;
                        //set in this way to make Date filter work
                        // setOldRecord(record)
                        record.sessionStartDate = new Date(v);
                      }}
                      //   onOk={(v) => {
                      //     console.log(v.toISOString())
                      //   }}
                      defaultValue={sessionStartDate ? dayjs(sessionStartDate) : ""}
                    />
                    <p style={{ fontSize: "12px" }}>
                      {" "}
                      Date: {new Date(sessionStartDate).toLocaleDateString()} <br /> Time: {new Date(sessionStartDate).toLocaleTimeString()}
                    </p>
                  </Tooltip>
                </>
              ) : (
                "N/A"
              ),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <div style={{ padding: 8 }}>
                <RangePicker
                  showTime={{ format: "HH:mm" }}
                  format="YYYY-MM-DD HH:mm"
                  value={selectedKeys[0] ? [selectedKeys[0], selectedKeys[1]] : []}
                  onChange={([from, to]) => setSelectedKeys([from, to])}
                  onOk={() => confirm()}
                />
                <Space>
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedKeys([]);
                      clearFilters();
                    }}
                    style={{ width: 90 }}
                  >
                    Reset
                  </button>
                  <button type="button" onClick={() => confirm()} style={{ width: 90 }}>
                    OK
                  </button>
                </Space>
              </div>
            ),
            // Customize the filter icon
            filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
          },
    // isAFS ?{
    //   width:0
    // }:isGLENTREE?{width: 0}:{
    //   title: "Last Report Date",
    //   dataIndex: "lastReportDate",
    //   sorter: false,
    //   width: 150,
    //   render: (orientationDate, record) =>
    //     orientationDate ? (
    //       <>
    //         {new Date(orientationDate).toDateString()}
    //         <div style={{ color: "lightgray" }}>
    //           {new Date(orientationDate).toLocaleTimeString()}
    //         </div>
    //       </>
    //     ) : (
    //       "N/A"
    //     ),
    //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    //       <div style={{ padding: 8 }}>
    //         <RangePicker
    //           showTime={{ format: 'HH:mm' }}
    //           format="YYYY-MM-DD HH:mm"
    //           value={selectedKeys[0] ? [selectedKeys[0], selectedKeys[1]] : []}
    //           onChange={([from, to]) => setSelectedKeys([from, to])}
    //           onOk={() => confirm()}
    //         />
    //         <Space>
    //           <button
    //             type="button"
    //             onClick={() => {
    //               setSelectedKeys([]);
    //               clearFilters();
    //             }}
    //             style={{ width: 90 }}
    //           >
    //             Reset
    //           </button>
    //           <button
    //             type="button"
    //             onClick={() => confirm()}
    //             style={{ width: 90 }}
    //           >
    //             OK
    //           </button>
    //         </Space>
    //       </div>
    //     ),
    //     // Customize the filter icon
    //     filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    // },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)", // 3 equal-width columns
              gap: "2px", // space between both rows & cols
            }}
          >
            {!isAFS && !isGLENTREE && (
              <Tooltip title="Edit">
                <Button
                  type="link"
                  shape="circle"
                  icon={<EditOutlined />}
                  onClick={() => {
                    // form.resetFields()
                    // form.setFieldsValue(record)
                    // if (record.orientationDate) {
                    //   const date = dayjs(record.orientationDate)
                    //   form.setFieldValue("date", date)
                    //   form.setFieldValue("time", date)
                    // }
                    // if (record.nextFollowUp) {
                    //   const date = dayjs(record.nextFollowUp)
                    //   form.setFieldValue("nextFollowUp", date)
                    //   // form.setFieldValue("time", date)
                    // }
                    // if (record.sessionStartDate) {
                    //   const date = dayjs(record.sessionStartDate)
                    //   form.setFieldValue("sessionStartDate", date)
                    //   // form.setFieldValue("time", date)
                    // }
                    // if (record.POC) {
                    //   form.setFieldValue("POC_Name", record.POC.name)
                    //   form.setFieldValue("POC_Phone", record.POC.contact)
                    //   form.setFieldValue("POC_Email", record.POC.email)
                    //   form.setFieldValue(
                    //     "POC_Designation",
                    //     record.POC.designation
                    //   )
                    // }
                    // setSchoolId({
                    //   ...schoolId,previousValue:record.schoolId
                    // })
                    // showModal()
                    console.log(record);

                    handleSave(record);
                  }}
                />
              </Tooltip>
            )}
            <Tooltip title="Get Analytics">
              <Button
                type="text"
                shape="circle"
                onClick={() => {
                  setData(record);
                  setModalLoading(true);
                  fetchSchoolId(record._id);
                }}
                icon={<PercentageOutlined style={{ color: "#45C153" }} />}
              />
            </Tooltip>
            {!isAFS && !isGLENTREE && (
              <Popconfirm
                title={
                  <div>
                    <p>Are you sure you want to send an email to the school?</p>
                    <p>This action will be irreversible...</p>
                    <RangePicker value={dateRangeReport} onChange={(dates) => setDateRangeReport(dates)} format="YYYY-MM-DD" />
                    {[0, 1, 2].map((offset) => {
                      const year = currentYear - offset;
                      return (
                        <Button key={year} onClick={() => setSessionYear(year)}>
                          {year} Session
                        </Button>
                      );
                    })}
                  </div>
                }
                placement="left"
                onConfirm={() => {
                  if (dateRangeReport) {
                    const [start, end] = dateRangeReport;
                    sendb2bOnboardingReport(record._id, start.toISOString(), end.toISOString());
                  } else {
                    sendb2bOnboardingReport(record._id, undefined, undefined);
                  }
                }}
                // icon={}
              >
                <Tooltip title="Send Registration Report">
                  <MailFilled style={{ color: "red" }} />
                </Tooltip>
                {/* <a>Send Email</a> */}
              </Popconfirm>
            )}
            {!isAFS && !isGLENTREE && (
              <Popconfirm
                title={
                  <div>
                    <p>Are you sure you want to send an email to the school?</p>
                    <p>This action will be irreversible...</p>
                    <RangePicker value={dateRangeReport} onChange={(dates) => setDateRangeReport(dates)} format="YYYY-MM-DD" />
                    {[0, 1, 2].map((offset) => {
                      const year = currentYear - offset;
                      return (
                        <Button key={year} onClick={() => setSessionYear(year)}>
                          {year} Session
                        </Button>
                      );
                    })}
                  </div>
                }
                placement="left"
                onConfirm={() => {
                  console.log(dateRangeReport);

                  if (dateRangeReport) {
                    const [start, end] = dateRangeReport;
                    sendMonthlyReport(record._id, start.toISOString(), end.toISOString());
                  } else {
                    sendMonthlyReport(record._id, undefined, undefined);
                  }
                }}

                // icon={}
              >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  {" "}
                  <Tooltip title="Send Progress Report" style={{ display: "flex", justifyContent: "center" }}>
                    {" "}
                    <SendOutlined style={{ color: "red" }} />{" "}
                  </Tooltip>{" "}
                </div>
              </Popconfirm>
            )}
            <Tooltip placement="left" title={`${record.name} Lead CRM`}>
              <Button
                type="text"
                shape="circle"
                onClick={() => navigate(`/b2b/school/leadcrm/${record._id}`)}
                icon={<NodeIndexOutlined style={{ color: "#971eff" }} />}
              />
            </Tooltip>
            <Tooltip placement="left" title={`${record.name} Student Report`}>
              <Button
                type="text"
                shape="circle"
                onClick={() => navigate(`/b2b/school/report/${record._id}`)}
                icon={<DiffOutlined style={{ color: "red" }} />}
              />
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  const renderHeader = () => {
    return (
      <Space size={16}>
        {!isAFS && !isGLENTREE && (
          <Button
            type="default"
            icon={<PlusOutlined />}
            onClick={() => {
              form.resetFields();
              setSchoolId({
                ...schoolId,
                previousValue: "",
              });
              showModal();
            }}
            loading={loading}
            style={{ backgroundColor: "#971eff", color: "white" }}
          >
            Add New Lead
          </Button>
        )}
        <Button
          type="default"
          icon={<ScissorOutlined />}
          onClick={() => {
            sessionStorage.clear();
            setTableParams({ ...tableParams, filters: {} });
          }}
          loading={loading}
        >
          Clear Filters
        </Button>
        <Button type="default" icon={<ReloadOutlined />} onClick={() => fetchSchool()} loading={loading}>
          Reload
        </Button>
      </Space>
    );
  };
  const handleTableChange = (pagination, filters, sorter, extra) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setSchool([]);
    }
  };
  const renderStatus = (_, record) => {
    if (record.nextFollowUp && new Date(record.nextFollowUp).toLocaleDateString() === new Date().toLocaleDateString())
      return <ClockCircleTwoTone twoToneColor="orange" style={{ fontSize: "15px" }} />;

    if (record.leadType === "CONVERTED") return <CheckOutlined twoToneColor="lightgreen" style={{ color: "green", fontSize: "15px" }} />;
  };

  const sendb2bOnboardingReport = async (value, startDate, endDate) => {
    try {
      const url = `${constants.NEW_DOMAIN}/api/v1/report/b2b/generateReportAfterOnBoarding`;
      const res = await axios.post(
        url,
        {
          schoolId: value,
          startDate,
          endDate,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
          },
        },
      );
      messageApi.open({
        type: "success",
        content: "Email Sent successfully",
      });
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.response.data.message || "Something went wrong",
      });
    }
  };

  const sendMonthlyReport = async (value, startDate, endDate) => {
    try {
      const url = `${constants.NEW_DOMAIN}/api/v1/report/b2b/sendMonthlyReport`;
      const res = await axios.post(
        url,
        {
          schoolId: value,
          startDate,
          endDate,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
          },
        },
      );
      messageApi.open({
        type: "success",
        content: "Email Sent successfully",
      });
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.response.data.message || "Something went wrong",
      });
    }
  };

  const acknowledged = async (value) => {
    try {
      const url = `${constants.NEW_DOMAIN}/api/v1/school/acknowledged`;
      const res = await axios.post(
        url,
        {
          schoolId: value,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
          },
        },
      );
      messageApi.open({
        type: "success",
        content: "Acknowledged successfully",
      });
      fetchSchool();
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.response.data.message || "Something went wrong",
      });
    }
  };

  const checkUserName = async (value) => {
    if (!/^[a-zA-Z0-9]+$/.test(value)) return;
    if (value === schoolId.previousValue) {
      return setSchoolId({ ...schoolId, verified: false });
    }
    try {
      const url = `${constants.NEW_DOMAIN}/api/v1/school/checkSchoolId`;
      const res = await axios.post(
        url,
        {
          schoolId: value,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
          },
        },
      );
      setSchoolId({
        ...schoolId,
        verified: false,
      });
    } catch (error) {
      setSchoolId({
        ...schoolId,
        verified: "This School Id is Already Taken",
      });
    }
  };

  const check = (value) => {
    const timerId = setTimeout(() => {
      if (value !== "") checkUserName(value);
    }, 1000); // Adjust the delay time (in milliseconds) as needed
    return () => clearTimeout(timerId);
  };

  if (loading) {
    return <Loader />;
  }

  const fetchFlotation = async () => {
    setLoading(true);
    try {
      const url = `${constants.NEW_DOMAIN}/api/v1/school/lastFloationSummary`;
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_JWT_TOKEN}`,
        },
      });

      setFilteredSchools(res.data.data || []);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const totalSchools = filteredSchools.length;
  const totalCount = filteredSchools.reduce((sum, school) => sum + school.count, 0);

  const handleDateRangeChange = async (dates, dateStrings) => {
    setDateRange(dates);
    fetchSchool(dateStrings);
  };

  const handleClearRange = () => {
    setDateRange(null);
    // fetchAnalytics();
  };
  return (
    <div style={{ backgroundColor: "#fff", padding: "20px" }}>
      {contextHolder}

      <Modal
        title="Add/Update Tab"
        open={open}
        // onOk={handleOk}
        // confirmLoading={confirmLoading}
        footer={""}
        style={{ height: "400px" }}
        scroll={true}
        onCancel={handleCancel}
      >
        <Card title="School Details">
          <Form
            layout="horizontal"
            form={form}
            size="medium"
            onFinish={handleSave}
            style={{
              maxWidth: 600,
              marginTop: "40px",
            }}
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 14,
            }}
          >
            <Form.Item
              label="School Id"
              name="schoolId"
              validateStatus={schoolId.verified ? "error" : ""}
              help={schoolId.verified || ""}
              rules={[
                {
                  required: true,
                  message: "School Id is required",
                },
              ]}
            >
              <Input
                placeholder="Enter School Id"
                onChange={(e) => {
                  check(e.target.value);
                }}
              />
            </Form.Item>
            <Form.Item
              label="School Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "School name is required",
                },
              ]}
            >
              <Input placeholder="Enter School" />
            </Form.Item>

            <Form.Item
              label="🌐City"
              name="city"
              rules={[
                {
                  required: true,
                  message: "City is required",
                },
              ]}
            >
              <AutoComplete
                options={options}
                style={{
                  width: 200,
                }}
                onSelect={onSelect}
                onSearch={async (text) => {
                  const res = await getPanelValue(text);
                  setOptions(res);
                }}
                placeholder="Enter City"
              />
            </Form.Item>

            {/* <Form.Item label="~ student strength" name="numberOfStudents">
              <Input type="tel" placeholder="eg : 100" />
            </Form.Item>
            <Form.Item label="🔗 WhatsApp Link" name="mainGroupLink">
              <Input placeholder="Link" />
            </Form.Item> */}
            <Form.Item label="Refferal Code" name="refferalCode">
              <Input disabled />
            </Form.Item>
            {/* <Form.Item
              label="🔗 Logo URL"
              name="logoUrl"
              rules={[
                {
                  type: "url",
                  warningOnly: true,
                  message: "Please Enter valid URL",
                },
              ]}
            >
              <Input placeholder="Logo URL" />
            </Form.Item> */}
            <Divider plain orientation="left" style={{ color: "gray" }}>
              Add POC details
            </Divider>
            <Form.Item label="Name" name="POC_Name">
              <Input placeholder="enter name" />
            </Form.Item>
            <Form.Item label="Designation" name="POC_Designation">
              <Input placeholder="eg : Teacher" />
            </Form.Item>
            <Form.Item
              label="📞 Phone"
              name="POC_Phone"
              rules={[
                { min: 10, message: "Please check phone number" },
                { max: 10, message: "Please check phone number" },
              ]}
            >
              <Input placeholder="phone number" type="tel" />
            </Form.Item>
            <Form.Item label="✉️ Email" name="POC_Email" rules={[{ type: "email", message: "Please check email" }]}>
              <Input placeholder="email@gmail.com" type="email" />
            </Form.Item>

            {/* <Divider plain orientation="left" style={{ color: "gray" }}>
              Orientation details
            </Divider>

            <Form.Item label="⏰Date & Time">
              <Space>
                <Form.Item name="date">
                  <DatePicker
                    placement="topLeft"
                    format="YYYY-MM-DD"
                    // style={{
                    //   width: "100%",
                    // }}
                  />
                </Form.Item>
                <Form.Item name="time">
                  <TimePicker showNow placement="topLeft" />
                </Form.Item>
              </Space>
            </Form.Item> */}

            <Divider plain orientation="left" style={{ color: "gray" }}>
              Others
            </Divider>
            {/* <Form.Item name="customPrice" label="💸Custom Price">
              <Input placeholder="999" />
            </Form.Item> */}
            <Form.Item label="⌚Next follow-up">
              <Form.Item name="nextFollowUp">
                <DatePicker
                  placement="topLeft"
                  format="YYYY-MM-DD"
                  // style={{
                  //   width: "100%",
                  // }}
                />
              </Form.Item>
            </Form.Item>
            <Form.Item label="Session Start Date">
              <Form.Item name="sessionStartDate">
                <DatePicker
                  placement="topLeft"
                  format="YYYY-MM-DD"
                  // style={{
                  //   width: "100%",
                  // }}
                />
              </Form.Item>
            </Form.Item>
            <Form.Item label="📝notes" name="notes">
              <TextArea rows={4} />
            </Form.Item>
            {/* <Form.Item
              name="inTake"
              label="Accept Response"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item
              name="showDubai"
              label="Show Dubai Program"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item
              name="showCosco"
              label="Show Cosco Program"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item> */}
            <Tooltip title="Show school in club onboarding form">
              <InfoCircleTwoTone
                style={{
                  fontSize: "16px",
                  color: "#08c",
                  marginLeft: `${isMobile ? "60px" : "200px"}`,
                  position: "absolute",
                  marginTop: "-46",
                }}
              />
            </Tooltip>
            <Form.Item name="leadType" label="Lead Type">
              <Select style={{ maxWidth: "200px" }}>
                <Option value="HOT">HOT</Option>
                <Option value="COLD">COLD</Option>
                <Option value="CONVERTED">CONVERTED</Option>
              </Select>
            </Form.Item>
            <Form.Item name="POC_V1" label="YouVah POC">
              <Select style={{ maxWidth: "200px" }}>
                <Option value="ROHIT">ROHIT</Option>
                <Option value="DEVESH">DEVESH</Option>
                <Option value="HIMANI">HIMANI</Option>
                <Option value="SHIKHA">SHIKHA</Option>
                <Option value="VINAY">VINAY</Option>
              </Select>
            </Form.Item>
            <Form.Item name="partner" label="Partner">
              <Select style={{ maxWidth: "200px" }}>
                <Option value="YOUVAH">YouVah</Option>
                <Option value="AFS">AFS</Option>
                <Option value="EW">EW</Option>
                <Option value="GLENTREE">GLENTREE</Option>
              </Select>
            </Form.Item>
            <Form.Item
              wrapperCol={
                width > 800
                  ? {
                      offset: 8,
                    }
                  : {}
              }
            >
              <Button type="primary" style={{ width: "200px" }} htmlType="submit">
                📂 Save
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Modal>
      {/* analytics */}
      {data && (
        <Modal
          // title={data.name + ", " + (data.city || "")}
          title={
            modalLoading ? (
              ""
            ) : (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <Avatar size={data.logoUrl ? 64 : 32} src={data.logoUrl} icon={!data.logoUrl && <HomeOutlined />} style={!data.logoUrl && { opacity: "0.3" }} />
                <p>{modalLoading ? "" : data.name + ", " + (data.city || "")}</p>
              </div>
            )
          }
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          okButtonProps={{
            display: false,
          }}
          footer={[]}
          style={{ maxWidth: isMobile ? "350px" : "500px", fontSize: "20px" }}
        >
          {modalLoading ? (
            <LoadingOutlined
              width={"50px"}
              style={{
                marginLeft: "43%",
                fontSize: "30px",
                marginTop: "10%",
              }}
            />
          ) : (
            <>
              <div style={{ display: "flex", alignItems: "center" }}>
                School Id :<p style={{ fontWeight: "bold", marginLeft: "4px" }}>{data.schoolId}</p>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                Group Link :{" "}
                <a style={{ fontWeight: "bold", marginLeft: "4px" }} href={"https://bit.ly/" + data.mainGroupLink} target="_blank">
                  {data.mainGroupLink ? "https://bit.ly/" + data.mainGroupLink : "Not Available"}
                </a>
              </div>
              <Divider>Registrations</Divider>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: isMobile ? "135px 125px" : "135px 125px 125px",
                  gridColumnGap: "20px",
                  gridRowGap: "20px",
                }}
              >
                <Card bordered={false}>
                  <Statistic
                    title={"Total revenue (INR)"}
                    value={analytics?.revenue}
                    // precision={2}
                    valueStyle={{ color: "black", fontSize: "20px" }}
                    // prefix={<ArrowDownOutlined />}
                  />
                </Card>
                <Card bordered={false}>
                  <Statistic
                    title={"Leads"}
                    value={analytics?.results}
                    // precision={2}
                    valueStyle={{ color: "black", fontSize: "20px" }}
                    // prefix={<ArrowDownOutlined />}
                  />
                </Card>
                <Card bordered={false}>
                  <Statistic
                    title={"Paid Users"}
                    value={analytics?.paid}
                    // precision={2}
                    valueStyle={{ color: "black", fontSize: "20px" }}
                    // prefix={<ArrowDownOutlined />}
                  />
                </Card>
                <Card bordered={false}>
                  <Statistic
                    title={"Training Completed"}
                    value={analytics?.training}
                    // precision={2}
                    valueStyle={{ color: "black", fontSize: "20px" }}
                    // prefix={<ArrowDownOutlined />}
                  />
                </Card>
                <Card bordered={false}>
                  <Statistic
                    title={"Assessment Completed"}
                    value={analytics?.assessment}
                    // precision={2}
                    valueStyle={{ color: "black", fontSize: "20px" }}
                    // prefix={<ArrowDownOutlined />}
                  />
                </Card>
                <Card bordered={false}>
                  <Statistic
                    title={"Internship Started"}
                    value={analytics?.internship}
                    // precision={2}
                    valueStyle={{ color: "black", fontSize: "20px" }}
                    // prefix={<ArrowDownOutlined />}
                  />
                </Card>
                <Card bordered={false}>
                  <Statistic
                    title={"Success Stories"}
                    value={analytics?.successStories}
                    // precision={2}
                    valueStyle={{ color: "black", fontSize: "20px" }}
                    // prefix={<ArrowDownOutlined />}
                  />
                </Card>
              </div>
            </>
          )}
        </Modal>
      )}

      <Row>
        <Col xs={24} md={20}>
          <div className="text-3xl">Schools</div>
          <p className="text-lg-light">
            {new Date().toDateString()} - {new Date().toLocaleTimeString()}
          </p>
        </Col>

        <Col xs={24} md={4}>
          <Statistic
            title="Total School Leads"
            loading={loading}
            value={tableParams.pagination.total}
            precision={0}
            valueStyle={{
              color: "blue",
            }}
            // prefix={<ArrowUpOutlined />}
            suffix="Schools"
          />
        </Col>
      </Row>
      {!isAFS && !isGLENTREE && (
        <div style={{ background: "white", border: "2px solid #971eff", width: "fit-content", borderRadius: "12px", padding: "1px" }}>
          <Segmented
            onChange={(e) => setViewType(e)}
            value={viewType}
            options={[
              {
                label: "CRM",
                value: "CRM",
                icon: <BarsOutlined />,
              },
              {
                label: "Flotation Summary",
                value: "FLOTATION",
                icon: <AppstoreOutlined />,
              },
              {
                label: "Followups",
                value: "FOLLOWUP",
                icon: <RocketTwoTone />,
              },
            ]}
          />
        </div>
      )}
      {viewType === "FOLLOWUP" && (
        <Card style={{ marginTop: 24 }}>
          <Space>
            <RangePicker value={dateRange} onChange={handleDateRangeChange} style={{ width: 300 }} />
            <Button icon={<ClearOutlined />} onClick={handleClearRange} disabled={!dateRange}>
              Clear Range
            </Button>
          </Space>
        </Card>
      )}
      {(viewType === "CRM" || viewType === "FOLLOWUP") && (
        <Table
          columns={columns}
          loading={tableLoading}
          title={renderHeader}
          size="medium"
          rowClassName="row"
          dataSource={school}
          onChange={handleTableChange}
          pagination={tableParams.pagination}
          rowKey={(record) => record._id}
          scroll={{
            x: 900,
            y: 500,
          }}
        />
      )}
      {viewType === "FLOTATION" && (
        <div className="dashboard-container">
          <h2 className="dashboard-title">Flotation Summary ( Last 3 Days )</h2>

          {/* Search bar */}
          {/* <div className="search-container">
          <div className="search-icon">
            <Search size={18} />
          </div>
          <input
            type="text"
            className="search-input"
            placeholder="Search schools..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            disabled={loading}
          />
        </div> */}

          {/* Summary stats */}
          <div className="stats-container">
            <div className="stat-card blue">
              <p className="stat-label">Total Schools</p>
              <p className="stat-value">{loading ? "-" : totalSchools}</p>
            </div>
            <div className="stat-card green">
              <p className="stat-label">Total Engagements</p>
              <p className="stat-value">{loading ? "-" : totalCount}</p>
            </div>
          </div>

          {/* Loading state */}
          {loading ? (
            <div className="loading-container">
              <Loader2 className="loading-spinner" />
              <span className="loading-text">Loading school data...</span>
            </div>
          ) : (
            /* Data table */
            <div className="table-container">
              <table className="data-table">
                <thead>
                  <tr>
                    <th
                      // onClick={() => requestSort('schoolName')}
                      className="sortable-header"
                    >
                      <div className="header-content">
                        School Name
                        {/* {getSortIcon('schoolName')} */}
                      </div>
                    </th>
                    <th
                      // onClick={() => requestSort('count')}
                      className="sortable-header count-header"
                    >
                      <div className="header-content">
                        Lead Count
                        {/* {getSortIcon('count')} */}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSchools
                    .sort((a, b) => b.count - a.count)
                    .map((school) => (
                      <tr key={school.schoolId}>
                        <td className="school-name-cell">{school.schoolName}</td>
                        <td className="count-cell">
                          <span className="count-badge">{school.count}</span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>

              {filteredSchools.length === 0 && !loading && <div className="no-results">No schools found matching your search criteria.</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default AddLead;
